

<div class="right"><button  mat-raised-button (click)="openDialog()"> Invite Student </button>
</div> 
<app-messages
  orgId="{{orgId}}"
  entityId="{{entityId}}"
  authLevel="{{authLevel}}"
  orgName="{{orgName}}"

></app-messages>